import { render, staticRenderFns } from "./RmIncoming.vue?vue&type=template&id=b573fdcc&scoped=true"
import script from "./RmIncoming.vue?vue&type=script&lang=js"
export * from "./RmIncoming.vue?vue&type=script&lang=js"
import style0 from "./RmIncoming.vue?vue&type=style&index=0&id=b573fdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b573fdcc",
  null
  
)

export default component.exports